import { trpc } from '@/shared/api';

/** 잉크 색상 마스터 목록 조회 — 살아 있는 잉크만, 이름 오름차순. */
export const useInkColorsQuery = () => trpc.productManagement.inkColors.list.useQuery();
